<style scoped>

.layers {

  /**
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    position: absolute;
    overflow: hidden; **/
}
.layer-card-content {
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  position: absolute;
  overflow: hidden;
}

.box-menu {
    position: absolute;
    top: 0px;
    right: 0px;
}

.layer-icon {
    font-size: 8px;
}

</style>

<template>

<div class="layers">
    <!--<layer v-for="chart in grid.layers" v-bind:chart="chart" v-bind:mode="mode" />-->

    <layer v-if="grid.layers && grid.layers.length" v-bind:chart="grid.layers[0]" v-bind:mode="mode" />
    <div class="box-menu" v-if="activeGrid.id == grid.id && mode != 'view'">
        <chart-parameters v-bind:chart="activeLayer" v-bind:grid="grid" v-bind:mode="mode" />
    </div>
</div>

</template>

<script>

// import Layer from './Layer.vue'
const Layer = () => import('./Layer.vue');
// import ChartParameters from '@/components/charts/Parameter.vue';
const ChartParameters = () => import('@/components/charts/Parameter.vue');

import {createNamespacedHelpers} from 'vuex'
const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('charts')

export default {
    name: 'Layers',
    props: ['grid', 'mode'],
    data: function() {
        return {
          fav: true,
      menu: false,
      message: false,
      hints: true,
            layers: [
              {
                component: 'blank',
                properties: {}
            },
            {
                component: 'defaultchart',
                properties: {
                    type: 'donut',
                    width: 380,
                    options: {},
                    series: [44, 55, 41, 17, 15]
                }
            }
          ],
          defaultLayer:   {
              component: 'blank',
              properties: {}
          }
        }
    },
    computed: {
      ...mapState(['activeGrid', 'activeGridId', 'activeLayer'])
    },
    components: {
        'layer': Layer,
        'chart-parameters': ChartParameters
    },
    methods: {
      ...mapMutations(['mToggleGridMenu', 'mSetDialog', 'mAdd', 'mSetProjectId', 'mSetTypeGroup', 'mSet', 'mSetName', 'mToggleEditable']),
      ...mapActions(['aRemoveGrid','aCreateRandomDashboard', 'aAdd', 'aInit', 'aUpdate', 'aSet', 'aDelete', 'aResized', 'aAddGrid', 'aActivateGrid']),
      addLayer: function() {
        this.layers.push(this.defaultLayer);
      },
      removeLayer: function() {
        if(this.activeLayer) {
          this.layers.splice(this.layers.indexOf(activeLayer), 1);
        } else {
          console.log("removeTopLayer");
          this.removeTopLayer();
        }
      },
      removeTopLayer: function() {
        this.layers.splice(-1,1)
      }
    },
    mounted: function() {

    }
}

</script>
